// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"579":"3ea4f35f","607":"4728528e","671":"092d4458","787":"c1112931"}[chunkId] + ".chunk.js";
};